import React from "react";
import PropTypes from "prop-types";
import { LoaderCircle } from "lucide-react";

export const BUTTON_VARIANTS = ["primary", "outline", "ghost", "destructive"];
export const BUTTON_SIZES = ["compact", "default", "large"];

const Button = ({
  children,
  className = "",
  disabled = false,
  fullWidth = false,
  icon: Icon,
  iconPosition = "start",
  loading = false,
  loadingLabel = "Working...",
  size = "default",
  type = "button",
  variant = "primary",
  ...buttonProps
}) => {
  const classes = [
    "wsm-button",
    `wsm-button--${variant}`,
    size !== "default" && `wsm-button--${size}`,
    fullWidth && "wsm-button--full-width",
    className,
  ].filter(Boolean);

  const DisplayIcon = loading ? LoaderCircle : Icon;
  const iconClasses = [
    "wsm-button__icon",
    loading && "wsm-button__spinner",
  ].filter(Boolean).join(" ");
  const content = loading ? loadingLabel : children;

  return (
    <button
      {...buttonProps}
      aria-busy={loading || undefined}
      className={classes.join(" ")}
      disabled={disabled || loading}
      type={type}
    >
      {DisplayIcon && iconPosition === "start" && (
        <DisplayIcon aria-hidden="true" className={iconClasses} />
      )}
      <span>{content}</span>
      {DisplayIcon && iconPosition === "end" && (
        <DisplayIcon aria-hidden="true" className={iconClasses} />
      )}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  icon: PropTypes.elementType,
  iconPosition: PropTypes.oneOf(["start", "end"]),
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  size: PropTypes.oneOf(BUTTON_SIZES),
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
};

export default Button;
